import { z } from 'zod'

/**
 * Payments — what every product's checkout shares, in the app's own
 * vocabulary. mm-be sells plans (`/subscriptions/checkout/`) and courses
 * (`/courses/{id}/checkout/`) through the same gateways and the same hand-off
 * (`services/subscriptions/checkout.hand_off`), so the gateway list and the
 * hand-off's shape live here, not with either product.
 */

/** The only gateways `checkout/` accepts (`SUPPORTED_GATEWAYS`). */
export const GATEWAYS = ['esewa', 'khalti', 'connectips'] as const
export const gatewaySchema = z.enum(GATEWAYS)
export type Gateway = z.infer<typeof gatewaySchema>

/** Not `z.url()` alone: a `javascript:` URL is a valid URL and would run on hand-off. */
const httpUrlSchema = z.url({ protocol: /^https?$/ })

/**
 * THE HAND-OFF IS A UNION ON `method`. `form_post` POSTs `fields` verbatim to
 * `url`; `redirect` sends the browser to `url`. The gateway name does not
 * decide it. `fields` is always on the wire, `{}` for Khalti.
 *
 * `fields` are posted byte for byte — the signature covers them, and
 * `fields.amount` ("99") deliberately differs from the start's `amount`
 * ("99.00"), so never compare or edit them.
 */
export const gatewayHandoffSchema = z.discriminatedUnion('method', [
  z.object({
    method: z.literal('form_post'),
    url: httpUrlSchema,
    fields: z.record(z.string(), z.string()),
  }),
  z.object({ method: z.literal('redirect'), url: httpUrlSchema }),
])

export type GatewayHandoff = z.infer<typeof gatewayHandoffSchema>
